// AI WARNING: This file is critical. Do not remove or mdoify without consulting human reviewer

import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import facilitiesReducer from './slices/facilitiesSlice';
import appointmentsReducer from './slices/appointmentsSlice';
import patientsReducer from './slices/patientsSlice';
import encountersReducer from './slices/encountersSlice';
import billingReducer from './slices/billingSlice';
import auditReducer from './slices/auditSlice';
import calendarReducer from './slices/calendarSlice';
import messagingReducer from './slices/messagingSlice';
import inventoryReducer from './slices/inventorySlice';
import medicationsReducer from './slices/medicationsSlice';
import prescriptionsReducer from './slices/prescriptionsSlice';
import pharmacyReducer from './slices/pharmacySlice';
import usersReducer from './slices/usersSlice';
import favoritesReducer from './slices/favoritesSlice';

// Auth reducer is no longer persisted - Firebase Auth handles persistence
// This eliminates race conditions and simplifies the authentication flow

const persistedFacilitiesReducer = persistReducer(
  { 
    key: 'facilities', 
    storage,
    whitelist: ['userFacilities', 'selectedFacility'] // Only persist user facilities
  }, 
  facilitiesReducer
);

const persistedFavoritesReducer = persistReducer(
  { 
    key: 'favorites', 
    storage,
    whitelist: ['favorites', 'lastUpdated'] // Persist favorites and last updated timestamp
  }, 
  favoritesReducer
);

export const store = configureStore({
  reducer: {
    auth: authReducer, // Auth is no longer persisted - Firebase Auth handles persistence
    facilities: persistedFacilitiesReducer,
    appointments: appointmentsReducer,
    patients: patientsReducer,
    encounters: encountersReducer,
    billing: billingReducer,
    audit: auditReducer,
    calendar: calendarReducer,
    messaging: messagingReducer,
    inventory: inventoryReducer,
    medications: medicationsReducer,
    prescriptions: prescriptionsReducer,
    pharmacy: pharmacyReducer,
    users: usersReducer,
    favorites: persistedFavoritesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
